import { useEffect, useState } from "react";
import SessionIntro from "src/components/Report/SessionIntro";
import Page1 from "./Report/Page1";
import Page2 from "./Report/Page2";
import Page3 from "./Report/Page3";
import GreadingPage from "./Report/GreadingPage";
import Page4 from "./Report/Page4";
import Page5 from "./Report/Page5";
import Page6 from "./Report/Page6";
import Page7 from "./Report/Page7";
import Page8 from "./Report/Page8";
import Page6t from "./Report/Page6t";
import Page7t from "./Report/Page7t";
import Page17 from "./Report/Page17";
import Page19 from "./Report/Page19";
import Page20 from "./Report/Page20";
import Page21 from "./Report/Page21";
import Page22 from "./Report/Page22";
import Page23 from "./Report/page23";
import Pageb5 from "./Report/Pageb5";
import Page2t from "./Report/Page2t";
import Page3t from "./Report/Page3t";
import PageA from "./Report/PageA";
import PageB from "./Report/PageB";
import PageC from "./Report/PageC";
import PageD from "./Report/PageD";
import Page100 from "./Report/Page100";
import PageG1 from "./Report/PageG1";
import PageG2 from "./Report/PageG2";
import PageG3 from "./Report/PageG3";
import PageG4 from "./Report/PageG4";
import PageG5 from "./Report/PageG5";
import PageG6 from "./Report/PageG6";
import PageG7 from "./Report/PageG7";
import PageG8 from "./Report/PageG8";
import PageG9 from "./Report/PageG9";
import PageG10 from "./Report/PageG10";

export default function JobAnalysisPageReport({ jobReload }) {

  const [reload, setReload] = useState(0)

  useEffect(() => {
    setReload(reload => reload + 1)

  }, [jobReload])

  return (
    <>
      <Page1 />
      <Page2t />
      <Page3t />
      {/* <GreadingPage /> */}

      <SessionIntro
        sessionDesc="
                            در این فصل اطلاعات پایه‌ای و ویژگی‌های اساسی شغل ارائه گردیده است که شامل
                            وظایف عمومی و تخصصی، شرایط احراز، مسئولیت‌ها، مخاطرات، ارتباطات و ابزارهای مورد نیاز شغل می
                            باشد که می‌تواند مبنای بکارگیری، استخدام و توسعه کارکنان سازمان
                            قرار بگیرد.
                        "
        sessionTitle="اطلاعات پایه‌ای و ویژگی‌های شغل"
        sessionNumber={1}
        pageNumber={1}
      />
      <Page2 />
      {/* <SessionIntro
        sessionDesc="
                            در این فصل ویژگی‌های شغل ارائه گردیده است که شامل
                            مسئولیت‌های شغلی، مخاطرات شغلی، دامنه‌های ارتباطی و ابزارها و تجهیزات مورد نیاز شغل می
                            باشد که می‌تواند مبنای استخدام و توسعه کارکنان سازمان
                            قرار بگیرد.
                        "
        sessionTitle="ویژگی‌های شغل"
        sessionNumber={2}
        pageNumber={3}
      /> */}
      <Page3 />
      <Page4 />
      {/* <Page5t /> */}
      <Page6t />
      {/* <SessionIntro
        sessionDesc="
                        در این فصل شرایط احراز و قابلیت های پایه ای مورد نیاز
                        جهت تصدی این شغل ارائه گردید ه است که شامل
                        تحصیالت، سابقه، توانایی های جسمی و مهارتهای پایه می
                        باشد که می تواند مبنای استخدام و توسعه کارکنان سازمان
                        قرار بگیرد.
                        "
        sessionTitle="شرایط احراز شغل"
        sessionNumber={3}
        pageNumber={7}
      /> */}
      <Page8 />
      <SessionIntro
        sessionDesc="
                       در این فصل مهارتهای پایه ای مورد نیاز شغل در ابعاد ارتباطی، فناوری اطلاعات، قوانین و مقررات، استانداردهای مورد نیاز و شایستگی‌های عمومی و تخصصی مرتبط با شغل آورده شده است که علاوه بر نیازسنجی آموزشی می تواند در فرایند جذب، انتخاب و ارتقاء کارکنان نیز مورد استفاده قرار بگیرد.
                        "
        sessionTitle="مهارت‌ها و شایستگی‌های شغل"
        sessionNumber={2}
        pageNumber={9}
      />
      <Page7 />
      <Page7t />
      {/* <SessionIntro
        sessionDesc="
                       در این فصل اهم شایستگی ها و قابلیت های مورد نیاز شغل در ابعاد عمومی و تخصصی آورده شده است که در برگیرنده مجموعه ویژگی ها و توانایی هایی است که برخورداری از آنها منجر به عملکرد بهتر و متمایز در کارکنان می شود.
                        "
        sessionTitle="شایستگی‌های شغل"
        sessionNumber={5}
        pageNumber={12}
      /> */}
      <Pageb5 reload={reload} />
      <Page5 />
      <Page6 />
      <SessionIntro
        sessionDesc="در این فصل شاخص های ارزیابی کارکنان در ابعاد رفتاری (EVC)، دانش، مهارت و نگرش (KSA) و شاخص های عملکردی (PI) آورده شده است که مبنای اصلی نظام مدیریت عملکرد کارکنان در سازمانها می باشد.
                        "
        sessionTitle="شاخص‌های ارزیابی عملکرد"
        sessionNumber={3}
        pageNumber={16}
      />
      <Page17 />
      {/* <Page18 /> */}
      <Page19 />
      <SessionIntro
        sessionDesc="در این فصل ابعاد روانشناسی شغل در لحاظ گونه های شخصیتی انواع هوش، ویژگی های بارز رفتاری، علائق و رغبت های شغلی آورده شده است که مبنای اصلی نظام جذب، استخدام، انتخاب و ارتقاء کارکنان می باشد.
                        "
        sessionTitle="ویژگی‌های روانشناسی شغل"
        sessionNumber={4}
        pageNumber={19}
      />
      <Page20 />
      <Page21 />
      <Page22 />
      <Page23 />
      <SessionIntro
        sessionDesc="
               در این فصل شاخص های ارزشیابی و گریدینگ شغل براساس مدل G20 در 20 مولفه و 4 محور ارائه گردیده است و از مبانی اصلی نظام پرداخت حقوق و دستمزد در مدیریت منابع انسانی می باشد.
                "
        sessionTitle="گریدینگ شغل"
        sessionNumber={5}
        pageNumber={24}
      />
      <PageG1 reload={reload} />
      <PageG2 reload={reload} />
      <PageG3 reload={reload} />
      <PageG4 reload={reload} />
      <PageG5 reload={reload} />
      <PageG6 reload={reload} />
      <PageG7 reload={reload} />
      <PageG8 reload={reload} />
      <PageG9 reload={reload} />
      <PageG10 reload={reload} />
      <GreadingPage pageNumber={35} employeeScore={false} type={1} />
      <SessionIntro
        sessionDesc="
                در فرم های پیوست که منتج از تحلیل شرایط احراز پایه ای،
                حرفه ای و رفتاری مورد نیاز شغل می باشد، شایستگی های
                احراز شده در قالب شش فرم متناسب با نظام های محوری
                مدیریت منابع انسانی طراحی گردیده که ابزارمناسب جهت
                اجرا و کاربست یافته ها می باشد.
                "
        sessionTitle="ضمائم"
        sessionNumber={6}
        pageNumber={36}
      />
      <GreadingPage pageNumber={37} employeeScore={true} type={2} />
      <PageA />
      <PageB />
      <PageC />
      <PageD />
      <Page100 />
    </>
  );
}
